import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class ParallaxImages {
	constructor() {
		this.parallaxImages = document.querySelectorAll(".parallax-image") || false;
		this.init();
	}

	init() {
		if (!this.parallaxImages) return;

		// const scrollbar = window.Scrollbar || false
		// const offset = Math.max(innerHeight, innerWidth);
		let r = window.innerHeight / window.innerWidth;
		let offset = 768 > window.innerWidth ? 200 : 500 + 500 * r;

		// if (scrollbar) {
		// 	ScrollTrigger.scrollerProxy(document.body, {
		// 		scrollTop(value) {
		// 			if (arguments.length) {
		// 				scrollbar.scrollTop = value
		// 			}

		// 			return scrollbar.scrollTop
		// 		},
		// 	})

		// 	scrollbar.addListener(ScrollTrigger.update)

		// 	offset = 1000
		// }

		this.parallaxImages.forEach((element) => {
			const parent = element.closest(".parallax-wrapper");
			gsap.to(element, {
				y: `${-1 * offset * 0.65}`,
				ease: "none",
				// duration: 3,
				scrollTrigger: {
					trigger: parent,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
				},
			});
		});
	}
}
